import React, { useState, useCallback } from "react";
import { withStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Link } from "react-router-dom";
import { useScrollTrigger } from "@material-ui/core";
import { kebabCase } from 'lodash';
import { makeStyles } from "@material-ui/styles";
import ButtonSmg from '../ButtonSmg';
import { WrappedLinkRouter } from '../Link';

const useStyles = makeStyles(theme => ({
  button: {
    fontSize: "15px",
    color: "#222",
    border: 0,
    borderRadius: 3,
    padding: "0 20px",
    "&:focus": {
      backgroundColor: "transparent"
    },
    "&:hover": {
      backgroundColor: "transparent"
    }
  }
}));

const HeadMenu = withStyles({})(props => {
  const defaultTop = { top: "14px" };
  const hiddenTop = { top: "-30px" };
  // const [menuStyle, setMenuStyle] = useState(defaultTop);

  const scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100
  });

  return (
    <Menu
      elevation={0}
      variant={`menu`}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center"
      }}
      style={scrollTrigger ? hiddenTop : defaultTop}
      {...props}
    />
  );
});

const HeadMenuItem = withStyles(theme => ({}))(MenuItem);

export default function HeaderMenu({ item, onClick }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();
 
  const handleClick = useCallback(
    (event) => {
      if (onClick) {
        onClick(kebabCase(item.label));
      }

      setAnchorEl(event.currentTarget);
    },
    [onClick, item.label],
  );

  const handleClose = useCallback(
    () => {
      if (onClick) {
        onClick('');
      }
      setAnchorEl(null);
    },
    [onClick],
  );

  return (
    <div key={`hb-${item.key}`}>
      <ButtonSmg
        id={`btn-header-${item.key}`}
        aria-controls={`${item.key}`}
        aria-haspopup="true"
        variant="text"
        color="inherit"
        onClick={handleClick}
        size="large"
        className={classes.button}
        content={item.label}
        {...(!item.static) ? {
          component: WrappedLinkRouter,
          to: `/${item.key}`,
        } : {}}
      />
      {item.static && (
        <HeadMenu
          key={`hm-${item.key}`}
          id={`${item.key}`}
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          disableScrollLock={true}
        >
          {item.elemens.map(elem => (
            <HeadMenuItem
              key={`menu-${elem.key}`}
              id={`menu-${elem.key}`}
              component={Link}
              to={`/${elem.key}`}
              onClick={handleClose}
            >
              <ListItemText primary={`${elem.label}`} />
            </HeadMenuItem>
          ))}
        </HeadMenu>
      )}
    </div>
  );
}
